import styled from 'styled-components'
import PropTypes from 'prop-types'

const TagsStyled = styled.div`
  display: flex;
  align-items: center;
  span {
    font-weight: 700;
    padding: 3px 8px;
    border-radius: 11px;
    font-size: 12px;
    line-height: 16px;
    display: block;
    margin-right: 8px;
  }
  .new {
    background: #C2E6FD;
    color: #466E8C;
  }
  .free {
    background: #EED4FD;
    color: #764D98;
  }
  .basic {
    background: #CAEE98;
    color: #32651B;
  }
  .intermediate {
    background: #FBE685;
    color: #927E33;
  }
  .advanced {
    background: #FED2DD;
    color: #AB192A;
  }
  .challenge {
    background: #fab2ff;
    color: #471e55;
  }
  .responsive {
    background: #85fbd1;
    color: #00623f;
  }
  .desktop {
    background: #989af0;
    color: #ffffff;
  }
  .mobile {
    background: #009688;
    color: #8ffff5;
  }
`

function ProjecTags({ isNew, isFree, level, challenge, type }) {
  return (
    <TagsStyled>
      {isNew && (
        <span className="new">Nuevo</span>
      )}
      {challenge && (
        <span className="challenge">Reto</span>
      )}
      {isFree && (
        <span className="free">Gratuito</span>
      )}
      {type === 'RESPONSIVE' && (
        <span className="responsive">Responsive</span>
      )}
      {type === 'DESKTOP' && (
        <span className="desktop">Desktop</span>
      )}
      {type === 'MOBILE' && (
        <span className="mobile">Mobile</span>
      )}
      {level === 'BASIC' && (
        <span className="basic">Básico</span>
      )}
      {level === 'INTERMEDIATE' && (
        <span className="intermediate">Intermedio</span>
      )}
      {level === 'ADVANCED' && (
        <span className="advanced">Avanzado</span>
      )}
    </TagsStyled>
  )
}

ProjecTags.defaultProps = {
  isNew: false,
}

ProjecTags.propTypes = {
  isNew: PropTypes.bool,
  isFree: PropTypes.bool.isRequired,
  challenge: PropTypes.bool.isRequired,
  level: PropTypes.string.isRequired,
}

export default ProjecTags
